import { useState } from "react"

export const useGlobalStates = () => {
    
    //para el formulario
    const [showForm, setShowForm ] = useState(false)
    const [formOpeningMode, setFormOpeningMode] = useState('EDITABLE')

    // para la modal
    const [showExpenses, setShowExpenses ] = useState(false)
    const [showModalDeposit, setShowModalDeposit ] = useState(false)
    const [modalOpeningMode, setModalOpeningMode] = useState('EDITABLE')
    const [showTypeForm, setshowTypeForm] = useState('None')

    // para el steper
    const [stepApplilication, setStepApplilication] = useState(0)

    // para drop down
    const [anchorEl, setAnchorEl] = useState(null); // Para el elemento de anclaje


    return Object.freeze({
        showForm, setShowForm,
        formOpeningMode, setFormOpeningMode,
        stepApplilication, setStepApplilication,
        showModalDeposit, setShowModalDeposit,
        modalOpeningMode, setModalOpeningMode,
        showExpenses, setShowExpenses,
        anchorEl, setAnchorEl,
        showTypeForm, setshowTypeForm
    })
}